<template>
  <div  v-if="item && userType == 'B2B'" class="stock-av">
    <small>
      <b>
        {{ label_stock_availability }}
      </b>
    </small>
    <span :class="stockStatusIcon" class="status"></span>
    <small>{{ stockStatusText }}</small>
  </div>
</template> 

<script>
export default {
  name: "product-stock-availability-child",
  props: {
    data: {
      type: Object,
    },
    label_stock_availability: {
      type: String,
      default: "Stock Availability",
    },
    label_in_stock: {
      type: String,
      default: "In Stock",
    },
    label_available_for_backorder: {
      type: String,
      default: "Available for Backorder",
    },
    label_out_of_stock: {
      type: String,
      default: "Out of Stock – Call for info",
    },
  },
  data() {
    return {
      availabilityAU: null,
      locId: 25,
      regionId: 7,
      userType: 'B2C',
    };
  },
  mounted() { 
      this.isB2bUser();
      this.setRegionIds();},
  methods: {
    setRegionIds(){
      if (window.culture == 'en-nz') {
        this.locId = 16;
        this.regionId = 5;
      }
      if ((window.culture == 'en-us') || (window.culture == 'es-us')) {
        this.locId = 4;
        this.regionId = 4;
      }
    },
    async fetchAvailabilityForAU() {
      let responseAU = await axios.get(this.cartUrlAU, {
        withCredentials: true,
      });
      let availabilityAU = responseAU.data.stockStatus;

      if (this.components && this.components.length > 0) {
        let componentsAvailabilityAU = availabilityAU;
          if (typeof responseAU.data.components === "object") {
            for(const [key, value] of Object.entries(responseAU.data.components)) {
              if (value.stockStatus == "OUT_OF_STOCK") {
                componentsAvailabilityAU = value.stockStatus;
                break;
              } else if ((value.stockStatus == "BACKORDER")) {
                componentsAvailabilityAU = value.stockStatus;
              }
            }
          }
        availabilityAU = componentsAvailabilityAU;
      }
      this.availabilityAU = availabilityAU;

    },
    isItemNotForSale(item) {
      if (window.culture === 'en-us' || window.culture === 'en-es') {
        return item.custitemweb_item_not_for_sale_den === 1;
      }
      return false;
    },
    isB2bUser() {
      this.userType = this.$store.getters["auth/userType"]; 
    },
  },
  computed: {
    cartUrlAU() {
      let t = parseInt(Date.now() / 1000);
      return (
        "https://4073460.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=1944&deploy=1&compid=4073460&ns-at=AAEJ7tMQUQJ0VcvlpO7CweYXHyQVBn_B3XmhjJL5r7rXvV8Xp6A" +
        "&itemId=" +
        this.item.internalid +
        "&locId=" +
        this.locId +
        "&state=" +
        this.$store.state.auth.profile.address_state +
        '&t=' + t
      );
    },
    item() {
      let item = this.$store.getters["cart/getComponentByStockCode"](
        this.data.stockCode
      );
      return item ? item : null;
    },
    stockStatusIcon() {
      if (this.availabilityAU) {
        return this.stockAvailabilityClassAU;
      }

      if (this.item && this.isItemNotForSale(this.item)) {
        return "availability out_of_stock";
      }

      if (this.item && this.item.isinstock) {
        return "availability in_store";
      }

      if (this.item && !this.item.isinstock && this.item.isbackorderable && this.userType == 'B2B') {
        return "availability available_for_backorder";
      }
      return "availability out_of_stock";
    },
    stockStatusText() {
      if (this.availabilityAU) {
        return this.stockAvailabilityAU;
      }

      if (this.item && this.isItemNotForSale(this.item)) {
        return this.label_out_of_stock;
      }

      if (this.item && this.item.isinstock) {
        return this.label_in_stock;
      }

      if (this.item && !this.item.isinstock && this.item.isbackorderable  && this.userType == 'B2B') {
        return this.label_available_for_backorder;
      }
      return this.label_out_of_stock;
    },

    stockAvailabilityAU() {
      if (this.availabilityAU == "IN_STOCK") {
        return this.label_in_stock;
      } else if (
        this.availabilityAU == "BACKORDER" && this.userType == 'B2B'
      ) {
        return "Available for Backorder";
      } else if (
        this.availabilityAU == "CUSTOM_BUILD" ||
        this.availabilityAU == "OUT_OF_STOCK"
      ) {
        return "Out of stock – Call for info";
      }
    },
    stockAvailabilityClassAU() {
      if (this.availabilityAU == "IN_STOCK") {
        return "availability in_store";
      } else if (
        this.availabilityAU == "BACKORDER" && this.userType == 'B2B'
      ) {
        return "availability available_for_backorder";
      } else if (
        this.availabilityAU == "CUSTOM_BUILD" ||
        this.availabilityAU == "OUT_OF_STOCK"
      ) {
        return "availability out_of_stock";
      }
    },
  },
  // watch: {
  //   // item() {
  //   //   if (window.culture == "en-au" || window.culture == "en-nz") {
  //   //     this.fetchAvailabilityForAU();
  //   //   }
  //   // },
  // },
};
</script>

<style lang="scss" scoped>
.stock-av {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .availability {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 5px;
  }
  .status {
    margin: 0.6rem;
    &.in_store {
      background-color: green;
    }
    &.available_for_backorder {
      background-color: darkorange;
    }
    &.out_of_stock {
      background-color: darkred;
    }
  }
  @media screen and (max-width: 768px) {
    justify-content: center;
  }
}
</style>

